import { Component, Input } from '@angular/core';
import { RequestBuilderService } from '../../request-builder.service';
import { ActorActionEnum, Is_ANY_Download_Action, Is_Approve_Action, Is_Sign_Action, Is_Sign_OR_Approve_Action } from 'src/app/constants/actor-action.enum';
import { DocumentModel } from 'src/app/models/document.model';
import { DocumentActor } from 'src/app/models/actors';
import { WorkflowStep3 } from 'src/app/models/workflow';
import { Subscription } from 'rxjs';
import { DocumentTypeEnum } from 'src/app/constants/document-type.enum';

@Component({
  selector: 'app-action-table-document-actions',
  templateUrl: './action-table-document-actions.component.html'
})
export class ActionTableDocumentActionsComponent {

  @Input() action!: DocumentActor;
  @Input() document!: DocumentModel;
  @Input() showPlaceButton: boolean = false;

  signatureProviderClaim: string = "Advanced";
  public signatureProviders: any;
  cloudProvider: any;
  public workflowDataStep3: WorkflowStep3 = <WorkflowStep3>{};
  private workflowSubscription: Subscription | null = null;

  constructor(private requestBuilderService: RequestBuilderService) {
    this.workflowSubscription = this.requestBuilderService.workflowData$.subscribe(workflowData => {
      this.workflowDataStep3 = workflowData.step3;
    })
  }

  ngOnDestroy(): void {
    if (this.workflowSubscription) {
      this.workflowSubscription.unsubscribe();
    }
  }
  allowEditSignaturefield(action:ActorActionEnum):boolean{
    return this.isSignAction(action) && this.document && this.document.documentType == DocumentTypeEnum.RegularPdf
  }
  isDeleteAllowedForThisAction() {
    return this.action && !this.action.workflowPlaceholderId;
  }
  isSignOrApproveAction(action: ActorActionEnum) {
    return Is_Sign_OR_Approve_Action(action);
  }
  isSignAction(action: ActorActionEnum): boolean {
    return Is_Sign_Action(action);
  }
  isApproveAction(action: ActorActionEnum): boolean {
    return Is_Approve_Action(action);
  }
  isDownloadAction(action: ActorActionEnum): boolean {
    return Is_ANY_Download_Action(action);
  }

  changeCloudProvider(provider: string) {
    this.cloudProvider = this.signatureProviders.find((s: any) => s.code === provider);
  }

  OpenPDFViewer() {
    this.requestBuilderService.OpenPDFViewer({ documentGuid: this.document.id, actor: this.action.id, allowedMultipleSignaturefields: true });
  }

  DeleteActor() {
    this.requestBuilderService.DeleteActorFromRequest(this.action.id);
  }
}
